<template>
	<div class="menuList">
		<div v-for="(item, indexs) in data" :key="item.id.toString()">
			<el-menu-item @click="jump(item[editNameObj.path], item)" :index="item.id.toString()" v-if="!item.children">
				<p slot="title" class="menuList_child" :class="{'menuList_parent': item[editNameObj.src], 'menuList-circle': menuListClass(item[editNameObj.title])}">
					<span v-html="iconObj[item[editNameObj.src]]" class="iconfont"></span>
					<span>{{item[editNameObj.title]}}</span>
				</p>
			</el-menu-item>
			<el-submenu :index="item.id.toString()" v-else>
				<p slot="title" class="menuList_parent">
					<span v-html="iconObj[item[editNameObj.src]]" class="iconfont"></span>
					<span>{{item[editNameObj.title]}}</span>
				</p>
				<menu-item :data="item.children" @change="changes" :editNameObj="editNameObj" :needCircleObj="needCircleObj"></menu-item>
			</el-submenu>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'menu-item',
		props: {
			data: {
				type: Array,
				default: () => []
			},
			editNameObj: {
				type: Object,
				default: () => {
					return {
						path: 'path',
						title: 'title',
						src: 'src'
					}
				}
			},
			needCircleObj: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				// path: ''
				iconObj: {
					1: '&#xe640;', // 首页
					2: '&#xe643;', // 讲师中心
					3: '&#xe644;', // 课程中心
					4: '&#xe641;', // 订单中心
					5: '&#xe645;', // 素材库
					6: '&#xe646;', // 题库中心
					7: '&#xe647;', // 营销中心
					8: '&#xe648;', // 私域工具
					9: '&#xe649;', // 数据中心
					10: '&#xe64a;', // 消息管理
					11: '&#xe64b;', // 账户中心
					12: '&#xe64c;', // 帮助中心
					13: '&#xe650;', // 系统设置
					14: '&#xe705;', // 导出记录
					15: '&#xe603;', // 订购管理
				}
			}
		},
		computed: {
			menuListClass() {
				const obj = {
					'退款订单': 'refund',
					'申诉订单': 'appeal'
				}
				return (title) => {
					return obj[title] ? !!this.needCircleObj[obj[title]] : false
				}
			}
		},
		methods: {
			jump(path, item) {
				if(this.$route.path !== item.path) {
					this.$router.replace(path)
					for (const key in this.editNameObj) {
						if(item[key]) {
							item[key] = item[this.editNameObj[key]]
						}
					}
					this.$emit('change', item)
				}
				
			},
			changes(item) {
				for (const key in this.editNameObj) {
					if(item[key]) {
						item[key] = item[this.editNameObj[key]]
					}
				}
				this.$emit('change', item)
			}
		}
	}
</script>

<style lang="less" scoped>
	.menuList {
		width: 100%;
		.menuList_child {
			font-size: 12px;
			font-weight: 500;
			color: rgb(55, 56, 60);
		}
		.menuList_parent {
			font-size: 14px;
			font-weight: 500;
			color: rgb(55, 56, 60);
			display: flex;
			align-items: center;
			.iconfont {
				margin-right: 10px;
			}
		}
	}
</style>
<style lang="less">
	.menuList { 
		.el-menu-item {
			min-width: 190px;
			&:hover{
			background-color: #edf1fe;
			}
			&.is-active {
				.menuList_child {
					span {
						color: #5273EA;
					}
				}
			}
		}
	}
	.el-submenu__title:hover {
		background-color: #edf1fe;
	}
	.menuList-circle {
		position: relative;
		&::before {
			content: '';
			width: 8px;
			height: 8px;
			border-radius: 100%;
			position: absolute;
			background-color: #F56C6C;
			left: -17px;
			top: 14px;
		}
	}
</style>
